import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Roadmap } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { EmptyState } from 'shared/components/ui/empty-state';
import { PopupMenu } from 'shared/components/ui/popup-menu';
import { Goal } from 'shared/types/goal';

import { GoalDetailRoadmapAddMenu } from '../goal-detail-roadmap-add-menu';

type SubgoalsEmptyStateProps = {
  goal: Goal;
  onHide: () => void;
};

export const SubGoalsEmptyState: React.FC<SubgoalsEmptyStateProps> = ({
  goal,
  onHide,
}) => {
  const { t } = useTranslation();
  const addButtonRef = useRef<HTMLButtonElement>(null);
  const [isAddMenuOpen, setIsAddMenuOpen] = useState(false);

  const handleOpenAddMenu = () => setIsAddMenuOpen(true);
  const handleCloseAddMenu = () => setIsAddMenuOpen(false);

  return (
    <EmptyState
      icon={Roadmap}
      title={t('goal-detail.roadmap.empty.title')}
      description={t('goal-detail.roadmap.empty.message')}
    >
      <Button
        ref={addButtonRef}
        variant={Variants.ContainedLight}
        color={Colors.Primary}
        size={Sizes.Small}
        onClick={handleOpenAddMenu}
      >
        {t('goal-detail.roadmap.empty.action')}
      </Button>
      {isAddMenuOpen && (
        <PopupMenu
          referenceElement={addButtonRef}
          onOutside={handleCloseAddMenu}
          position="bottom-start"
        >
          <GoalDetailRoadmapAddMenu
            parentIds={[goal.id]}
            onClose={handleCloseAddMenu}
          />
        </PopupMenu>
      )}

      <Button
        variant={Variants.Text}
        color={Colors.TextSecondary}
        size={Sizes.Small}
        onClick={onHide}
      >
        {t('pages.goal-detail.roadmap.empty.caption')}
      </Button>
    </EmptyState>
  );
};
